/*=========================================================================================
  File Name: moduleSigepState.js
  Description: Sigep Module State
==========================================================================================*/

export default {
    info: [],
  }